import React from "react";
import { Table, Tab, Button } from "semantic-ui-react";
import _ from "lodash";
import { connect } from "react-redux";
import ResultHeader from "./ResultHeader";
import "../../assets/styles/sub-table.css";
import { getMenuItem } from "../common/PageHelper";
import {PiplResultRecord} from "./PiplResultRecord";
import api from "../../api";

class EmailPiplResult extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: "",
      persons: [],
      visibleCount: 0,
      displayRecords: undefined,
      tabHeader: null,
      lastInternalId: undefined,
      savedResultId: undefined,
      showLoadMore: false,
      loadMoreError: null,
      loading: false,
      emailCountOverrides: {},
    };
  }

  componentDidMount() {
    this.loadData(this.props);
    window.addEventListener("resize", this.updateDimensions);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.searchResultData !== this.props.searchResultData) {
      this.loadData(this.props);
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  onViewReportClick = (e, personId) => {
    this.setState({ displayMoreDetails: false });

    this.props.showReport("", "piplReport", personId, {
      internalNameID: personId,
      optReportType: "emailrep",
      bttype: this.props.userAccount.btType,
      reportID: 143,
    });
  };

  getEmailCount = (person) => {
    const { emailCountOverrides } = this.state;

    const personId = _.get(person, "$.internalID");

    if (emailCountOverrides[personId] !== undefined) {
      return emailCountOverrides[personId];
    }

    let value = _.get(
      person,
      "email_count[0]._"
    );

    if (!value) {
      value = _.get(
        person,
        "email_count[0]"
      );
    }

    return value !== undefined &&
      value !== null &&
      value !== ""
      ? parseInt(value, 10)
      : "NA";
  };

  loadMore = () => {
    const {lastInternalId, savedResultId, persons} = this.state;
    this.setState({loading: true});
    api.lp
      .piplRecordCounts({
        userID: this.props.user.userid,
        internalID : lastInternalId,
        savedResultID: savedResultId,
        sessionID: localStorage.getItem("sessionID"),
      })
      .then((res) => {
        const respError = res.data.Error;
        if(respError || respError !== null) {
          const loading = false;
          let loadMoreError = "Something went wrong. Please contact customer care";
          if(respError === "TryLater") {
            loadMoreError = "This is taking longer than usual, please try again";
          } else if(respError === "AllRevealed"){
            this.setState({showLoadMore: false, loading});
            return;
          }
          this.setState({loading, loadMoreError});
          return;
        }
        if(res.data.Data && Object.keys(res.data.Data).length > 0) {
          let visibleCount = this.state.visibleCount;
          const emailCountOverrides = {
            ...this.state.emailCountOverrides
          };
          _.forEach(res.data.Data, (val, internalId) => {
            if (val > 0) {
              emailCountOverrides[parseInt(internalId, 10)] = val;
              visibleCount += 1;
            }
          });                    
          const lastKey = Object.keys(res.data.Data)
            .filter(key => res.data.Data[key] > 0)
            .pop();
          const lastPersonInternalId = _.get(persons[persons.length - 1], "$.internalID");
          this.setState({emailCountOverrides, visibleCount, lastInternalId: lastKey || lastInternalId
            , showLoadMore: lastPersonInternalId !== lastKey, loading: false});
        }
        else {
          this.setState({loading: false});
        }
      }).catch(() => this.setState({loading: false}));
  };

  loadData = (props) => {
    const {
      searchResultData,
      additionalData,
      uiData,
    } = props;

    if (!searchResultData) {
      return;
    }

    const root = Object.keys(searchResultData)[0];

    const error = _.get(
      searchResultData,
      `${root}.errors[0].error[0]._`
    );

    if (error) {
      this.setState({
        error: error.indexOf("403") >= 0
          ? "This is taking longer than usual, please try again"
          : error,
        persons: [],
      });

      return;
    }

    let persons = _.get(
      searchResultData,
      `${root}.people[0].person`
    );

    if (!persons) {
      persons = _.get(
        searchResultData,
        `${root}.people[0].possible_persons[0].possible_person`
      );
    }
    if(!persons) {
      this.setState({error: "No email records found"})
      return;
    }
    const actId = _.get(searchResultData, `${root}.log[0].actID[0]`);
    persons = persons || [];

    const displayRecords = persons.filter((person) => {
      let emailCount = _.get(
        person,
        "email_count[0]._"
      );
      if(!emailCount)
        emailCount = _.get(
        person,
        "email_count[0]"
      );
      return emailCount !== undefined &&
        emailCount !== null &&
        emailCount !== "";
    });
    const lastProcessCount = _.findLastIndex(
      persons,
      (person) => person.email_count
    );
    let lastInternalId = "";
    if (
      lastProcessCount >= 0 &&
      persons.length > lastProcessCount
    ) {
      const lastProcessPerson = persons[lastProcessCount];

      if (lastProcessPerson) {
        lastInternalId = _.get(
          lastProcessPerson,
          "$.internalID"
        );
      }
    }    
    const lastPersonemailCount = _.get(
        persons[persons.length - 1],
        "email_count[0]._"
      );
    if(lastProcessCount === -1)
      lastInternalId = _.get(persons[0], "$.internalID");
    const reportId =
      additionalData &&
      additionalData.reportIds
        ? additionalData.reportIds[0]
        : undefined;

    const report = reportId
      ? _.find(
          uiData.Reports,
          (r) => r.ReportID === reportId
        )
      : undefined;

    this.setState({
      error: "",
      persons,
      visibleCount: displayRecords.length,
      displayRecords,
      lastInternalId,
      report,
      savedResultId: actId,
      showLoadMore: lastProcessCount === -1 || (lastInternalId !== "" && !lastPersonemailCount),
      tabHeader: (
        <ResultHeader {...props} />
      ),
      emailCountOverrides: {},
    });
  };

  renderPerson = (person, perindex) => {
    const {
      userAccount,
    } = this.props;

    const {
      report,
    } = this.state;

    const personId = _.get(person, "$.internalID");

    const name = _.get(
      person,
      "names[0].name[0].display[0]._",
      ""
    );

    const emailCount =
      this.getEmailCount(person);

    const hasOverride =
      this.state.emailCountOverrides[personId] !== undefined;

    const hasOriginalEmailCount =
      emailCount !== "NA";

    const isVisible =
      hasOriginalEmailCount || hasOverride;

    const colorClass =
      perindex % 2 === 0
        ? "odd-row"
        : "even-row";

    return (
      <Table
        key={`email_rec_${personId || perindex}`}
        className={isVisible ? "" : "hide-element"}
      >
        <Table.Body>
          <Table.Row className="result-header">
            <Table.Cell
              width={11}
              className="icon-align-middle padding-10"
            >
              {name}
            </Table.Cell>

            <Table.Cell
              width={5}
              className="text-right padding-10"
            >
              <div className="float-right-nomobile">
                <Button
                  primary
                  className={
                    userAccount.acctTheme === 0
                      ? "classic-submit"
                      : ""
                  }
                  onClick={(e) =>
                    this.onViewReportClick(
                      e,
                      personId
                    )
                  }
                >
                  View Report
                  {report &&
                  report.SearchResultCost !== undefined
                    ? ` - ${report.SearchResultCost}`
                    : ""}
                </Button>
              </div>
            </Table.Cell>
          </Table.Row>

          <Table.Row className={colorClass}>
            <Table.Cell colSpan={2}>
              <PiplResultRecord
                node={person}
                index={perindex}
                emailCount={emailCount}
                {...this.props}
              />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  };

  render() {
    const {
      userAccount,
    } = this.props;

    const {
      error,
      loadMoreError,
      persons,
      visibleCount,
      showLoadMore,
      tabHeader,
      loading
    } = this.state;
    const tabTitle = persons && persons.length > 0 && _.get(
        persons[0],
        "email_count[0]"
      ) === undefined ? "No matches in this batch - click Load More to check the rest" 
      : `${visibleCount} Matches Found`;

    if (error) {
      return (
        <Table stackable>
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <p className="red-text">
                  {error}
                </p>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }
    const tabs = [
      {
        menuItem: getMenuItem(
          userAccount.acctTheme,
          true,
          tabTitle
        ),

        render: () => (
          <Tab.Pane key="rec_tab">
            {tabHeader}

            {persons.map(this.renderPerson)}
            {loadMoreError && <p className="coverage-table-header padding-10 red-text">{loadMoreError}</p>}
            {showLoadMore && (
              <p className="coverage-table-header padding-10">
                <Button
                  primary
                  className={
                    userAccount.acctTheme === 0
                      ? "classic-submit width-100-percent"
                      : "width-100-percent"
                  }
                  onClick={this.loadMore}
                  loading={loading}
                >
                  Load More
                </Button>
              </p>
            )}
          </Tab.Pane>
        ),
      },
    ];

    return <Tab panes={tabs} />;
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    userAccount: state.userAccount,
    uiData: state.uiData,
  };
}

export default connect(
  mapStateToProps,
  null
)(EmailPiplResult);


// WEBPACK FOOTER //
// ./src/components/searchresults/EmailPiplResult.js